const SERIE_1100 = [
  '1101',
  '1102',
  '1103',
  '1104',
  '1105',
  '1106',
  '1107',
  '1108',
  '1143',
  '1144',
  '1145',
  '1146',
  '1147',
  '1148'
];

const SERIE_1200 = [
  '1201',
  '1202',
  '1203',
  '1204',
  '1205',
  '1206',
  '1207',
  '1208',
  '1209',
  '1210',
  '1211',
  '1224',
  '1225',
  '1226',
  '1227',
  '1242',
  '1243',
  '1245',
  '1247',
  '1248',
  '1249',
  '1250',
  '1259',
  '1264'
];

export const FUMIGATION_SERIES = [
  // Methyl Bromide Fumigation Methods (With or without chloropicrin) - 1100 series
  {
    name: '1101-1190 series',
    codes: [...SERIE_1100, '1109', '1149', '1190']
  },

  // 1,3-Dichloropropene Fumigation Methods (with or without chloropicrin) - 1200 series
  {
    name: '1201-1290 series',
    codes: [...SERIE_1200, '1230', '1290']
  },

  // Chloropicrin-Fumigation Methods - 1100 - 1300 series
  {
    name: '1101-1390 series',
    codes: [...SERIE_1100, ...SERIE_1200, '1390']
  },

  // Metam-Sodium and Metam-Potassium Fumigation Methods - 1400 series
  {
    name: '1401-1490 series',
    codes: [
      '1401',
      '1402',
      '1403',
      '1404',
      '1405',
      '1406',
      '1407',
      '1408',
      '1409',
      '1410',
      '1411',
      '1412',
      '1413',
      '1447',
      '1452',
      '1455',
      '1472',
      '1490'
    ]
  },

  // Dazomet Fumigation Methods - 1500 series
  { name: '1501-1590 series', codes: ['1501', '1502', '1590'] },

  // Sodium Tetrathiocarbonate Fumigation Methods - 1600 series
  {
    name: '1601-1690 series',
    codes: ['1601', '1602', '1603', '1604', '1605', '1690']
  },

  // Methyl Iodide Fumigation Methods - 1700 series
  { name: '1701-1705 series', codes: ['1701', '1702', '1703', '1704', '1705'] }
];

export const APPLICATOR_TYPES = [
  {
    key: 'grower',
    value: 'Grower Applied'
  },
  {
    key: 'pco',
    value: 'PCO Applied'
  }
];

export const PCO_APPLICATOR_TYPES = [
  {
    key: 'PCB',
    value: 'PCB'
  },
  {
    key: 'PCM',
    value: 'PCM'
  },
  {
    key: 'APC',
    value: 'APC'
  },
  {
    key: 'JPC',
    value: 'JPC'
  },
  {
    key: 'PAC',
    value: 'PAC'
  },
  {
    key: 'UAPC',
    value: 'UAPC'
  },
  {
    key: 'UJPC',
    value: 'UJPC'
  },
  {
    key: 'VCT',
    value: 'VCT'
  }
];

export const PROPERTIES_SELECTION_STEP = 2;

export const DUPLICATION_ERROR_MESSAGES = [
  'Duplicate lines were detected',
  'This records were already submitted, no action is needed.',
  'duplicate lines detected'
];

export const FUMIGATION_CODES = {
  fumigation: [
    {
      method: 1101,
      description: 'Methyl Bromide/Chloropicrin - Nontarpaulin/shallow/bed'
    },
    {
      method: 1102,
      description: 'Methyl Bromide/Chloropicrin - Nontarpaulin/deep/broadcast'
    },
    {
      method: 1103,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/broadcast – Noble plow'
    },
    {
      method: 1104,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/broadcast – Noble plow – strip'
    },
    {
      method: 1105,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/broadcast – closing shoes and compaction roller'
    },
    {
      method: 1106,
      description: 'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/bed'
    },
    {
      method: 1107,
      description: 'Methyl Bromide/Chloropicrin - Tarpaulin/deep/broadcast'
    },
    {
      method: 1108,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/deep/broadcast – strip'
    },
    {
      method: 1109,
      description: 'Methyl Bromide - Drip system – hot gas'
    },
    {
      method: 1143,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/broadcast – Noble plow – with tarp eligible for 60% credit'
    },
    {
      method: 1144,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/broadcast – Noble plow – strip – with tarp eligible for 60% credit'
    },
    {
      method: 1145,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/broadcast – closing shoes and compaction roller – with tarp eligible for 60% credit'
    },
    {
      method: 1146,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/shallow/bed – with tarp eligible for 60% credit'
    },
    {
      method: 1147,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/deep/broadcast – with tarp eligible for 60% credit'
    },
    {
      method: 1148,
      description:
        'Methyl Bromide/Chloropicrin - Tarpaulin/deep/broadcast – strip – with tarp eligible for 60% credit'
    },
    {
      method: 1149,
      description:
        'Methyl Bromide - Drip system – hot gas – with tarp eligible for 60% credit'
    },
    {
      method: 1190,
      description:
        'Methyl Bromide - Other label method for methyl bromide (with or without chloropicrin)'
    },
    {
      method: 1201,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/shallow/broadcast or bed'
    },
    {
      method: 1202,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/shallow/broadcast'
    },
    {
      method: 1203,
      description: '1,3-Dichloropropene/Chloropicrin - Tarpaulin/shallow/bed'
    },
    {
      method: 1204,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/shallow/broadcast or bed/three water treatments'
    },
    {
      method: 1205,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/shallow/bed/three water treatments'
    },
    {
      method: 1206,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/deep/broadcast'
    },
    {
      method: 1207,
      description: '1,3-Dichloropropene/Chloropicrin - Tarpaulin/deep/broadcast'
    },
    {
      method: 1208,
      description: '1,3-Dichloropropene/Chloropicrin - Tarpaulin/deep/bed'
    },
    {
      method: 1209,
      description:
        '1,3-Dichloropropene/Chloropicrin - Chemigation (drip system)/tarpaulin'
    },
    {
      method: 1210,
      description: '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/deep/strip'
    },
    {
      method: 1211,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/deep/GPS targeted'
    },
    {
      method: 1224,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/24 inches deep/broadcast'
    },
    {
      method: 1225,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/24 inches deep/broadcast'
    },
    {
      method: 1226,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/24 inches deep/strip'
    },
    {
      method: 1227,
      description:
        '1,3-Dichloropropene/Chloropicrin - Nontarpaulin/24 inches deep/GPS targeted'
    },
    {
      method: 1230,
      description: '1,3-Dichloropropene - Nontarpaulin/tree-hole'
    },
    {
      method: 1242,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/shallow/broadcast – with tarp eligible for 60% credit'
    },
    {
      method: 1243,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/shallow/bed – with tarp eligible for 60% credit'
    },
    {
      method: 1245,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/shallow/bed/three water treatments – with tarp eligible for 60% credit'
    },
    {
      method: 1247,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/deep/broadcast – with tarp eligible for 60% credit'
    },
    {
      method: 1248,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/deep/bed – with tarp eligible for 60% credit'
    },
    {
      method: 1249,
      description:
        '1,3-Dichloropropene/Chloropicrin - Tarpaulin/deep/strip – with tarp eligible for 60% credit'
    },
    {
      method: 1250,
      description:
        '1,3-Dichloropropene/Chloropicrin - 40% TIF tarpaulin/deep/broadcast'
    },
    {
      method: 1259,
      description:
        '1,3-Dichloropropene/Chloropicrin - Chemigation (drip system)/TIF tarpaulin'
    },
    {
      method: 1264,
      description:
        '1,3-Dichloropropene/Chloropicrin - 40% TIF tarpaulin/24 inches deep/broadcast'
    },
    {
      method: 1290,
      description:
        '1,3-Dichloropropene - Other label method for 1,3-dichloropropene (with or without chloropicrin)'
    },
    {
      method: 1390,
      description: 'Chloropicrin - Other label method for chloropicrin'
    },
    {
      method: 1401,
      description:
        'Metam Sodium/Potassium - Sprinkler/broadcast or bed/one water treatment'
    },
    {
      method: 1402,
      description:
        'Metam Sodium/Potassium - Sprinkler/broadcast or bed/two water treatments'
    },
    {
      method: 1403,
      description:
        'Metam Sodium/Potassium - Sprinkler/broadcast or bed/three water treatments'
    },
    {
      method: 1404,
      description:
        'Metam Sodium/Potassium - Nontarpaulin/shallow/broadcast or bed/one water treatment'
    },
    {
      method: 1405,
      description:
        'Metam Sodium/Potassium - Nontarpaulin/shallow/broadcast or bed/two water treatments'
    },
    {
      method: 1406,
      description:
        'Metam Sodium/Potassium - Nontarpaulin/shallow/broadcast or bed/three water treatments'
    },
    {
      method: 1407,
      description:
        'Metam Sodium/Potassium - Chemigation (drip system) tarpaulin'
    },
    {
      method: 1408,
      description:
        'Metam Sodium/Potassium - Chemigation (drip system) nontarpaulin'
    },
    {
      method: 1409,
      description: 'Metam Sodium/Potassium - Rotary tiller'
    },
    {
      method: 1410,
      description: 'Metam Sodium/Potassium - Power mulcher'
    },
    {
      method: 1411,
      description: 'Metam Sodium/Potassium - Soil capping'
    },
    {
      method: 1412,
      description: 'Metam Sodium/Potassium - Flood'
    },
    {
      method: 1413,
      description: 'Metam Sodium/Potassium - Drench'
    },
    {
      method: 1447,
      description:
        'Metam Sodium/Potassium - Chemigation (drip system) tarpaulin – with tarp eligible for 30% credit'
    },
    {
      method: 1452,
      description:
        'Metam Sodium/Potassium - Night 1A.M. start/sprinkler/broadcast or bed/two water treatments'
    },
    {
      method: 1455,
      description:
        'Metam Sodium/Potassium - 1A.M. start/nontarpaulin/shallow/broadcast or bed/two water treatments'
    },
    {
      method: 1472,
      description:
        'Metam Sodium/Potassium - 4A.M. start/sprinkler/broadcast or bed/two water treatments'
    },
    {
      method: 1490,
      description:
        'Metam Sodium/Potassium - Other label method for metam-sodium and metam-potassium'
    },
    {
      method: 1501,
      description: 'Dazomet - Soil incorporation'
    },
    {
      method: 1502,
      description: 'Dazomet - Surface application – water incorporation'
    },
    {
      method: 1590,
      description: 'Dazomet - Other label method for dazomet'
    },
    {
      method: 1601,
      description: 'Sodium Tetrathiocarbonate - Chemigation (drip)'
    },
    {
      method: 1602,
      description: 'Sodium Tetrathiocarbonate - Chemigation (mini-sprinkler)'
    },
    {
      method: 1603,
      description: 'Sodium Tetrathiocarbonate - Chemigation (flood, basin)'
    },
    {
      method: 1604,
      description: 'Sodium Tetrathiocarbonate - Chemigation (furrow, border)'
    },
    {
      method: 1605,
      description:
        'Sodium Tetrathiocarbonate - Chemigation (foggers, jets, misters, other)'
    },
    {
      method: 1690,
      description:
        'Sodium Tetrathiocarbonate - Other label method for sodium tetrathiocarbonate'
    },
    {
      method: 5149,
      description: 'Outdoor - Other fumigations (e.g., field burrow fumigation)'
    },
    {
      method: 5173,
      description: 'Enclosed space - fumigants (e.g., greenhouse fumigation)'
    }
  ],
  ground: [
    {
      method: 5101,
      description:
        'Ground-rig sprayer (no dust, powder, or fumigant application) (no airblast sprayer)'
    },
    {
      method: 5102,
      description:
        'Air blast or air-carrier sprayer (no dust or powder application)'
    },
    {
      method: 5104,
      description: 'Dust or powder (except field soil injection)'
    },
    {
      method: 5106,
      description:
        'Granule, flake, or pellet (e.g., mechanical spreaders) (no fumigants)'
    },
    {
      method: 5111,
      description:
        'Field soil injection (no dusts, powders, fumigants, or chemigation)'
    },
    {
      method: 5112,
      description: 'Field soil injection - dust or powder only'
    },
    {
      method: 5161,
      description:
        'Chemigation: sprinkler (e.g., solid set, lateral move, traveling gun) (no fumigants)'
    },
    {
      method: 5171,
      description:
        'Enclosed space application (e.g., greenhouse/mushroom house, any equipment) (no fumigants)'
    },
    {
      method: 5199,
      description:
        'Unspecified (ground or other application equipment not listed)'
    }
  ],
  other: [
    {
      method: 5102,
      description:
        'Air blast or air-carrier sprayer (no dust or powder application)'
    },
    {
      method: 5104,
      description: 'Dust or powder (except field soil injection)'
    },
    {
      method: 5106,
      description:
        'Granule, flake, or pellet (e.g., mechanical spreaders) (no fumigants)'
    },
    {
      method: 5112,
      description: 'Field soil injection - dust or powder only'
    },
    {
      method: 5121,
      description:
        'Manual placement (e.g., twist ties) (no dusts, powders, fumigants)'
    },
    {
      method: 5122,
      description: 'Hand pump sprayer (no dust, powder, or fumigant)'
    },
    {
      method: 5123,
      description: 'Backpack sprayer (no dust or powder) (no airblast sprayer)'
    },
    {
      method: 5129,
      description: 'Other hand-held (no dusts, powders, or fumigants)'
    },
    {
      method: 5131,
      description: 'Bait station'
    },
    {
      method: 5161,
      description:
        'Chemigation: sprinkler (e.g., solid set, lateral move, traveling gun) (no fumigants)'
    },
    {
      method: 5162,
      description:
        'Chemigation: micro-irrigation (e.g., drip, trickle, micro-sprinkler) (no fumigants)'
    },
    {
      method: 5163,
      description:
        'Chemigation: surface/gravity flow (e.g., flood, furrow) (no fumigants)'
    },
    {
      method: 5169,
      description: 'Chemigation: other method (no fumigants)'
    },
    {
      method: 5171,
      description:
        'Enclosed space application (e.g., greenhouse/mushroom house, any equipment) (no fumigants)'
    },
    {
      method: 5199,
      description:
        'Unspecified (ground or other application equipment not listed)'
    }
  ]
};

const METHOD_CODE_GROUP_BY_CALAG_METHOD = {
  F: 'fumigation',
  G: 'ground',
  O: 'other'
};

export const getMethodCodeOptionsByGroup = calAgMethodGroup => {
  return (
    FUMIGATION_CODES[METHOD_CODE_GROUP_BY_CALAG_METHOD[calAgMethodGroup]] || []
  );
};
